import ArchiveArticle from './archive-article';
export default function(params) {
  var self = this;

  self.mapping = {
    'articles': {
      create: function(options) {
        return new ArchiveArticle(options.data);
      }
    }
  };

  self.archivedArticles = ko.observableArray();
  self.pagination = ko.observable();

  self.initUI = function() {
    Kadenze.PaginationBinding.applyBindingsWithTextInput(self.request, $('#archived-articles-title'));
  };

  self.bindData = function(data) {
    var json;

    try {
      json = JSON.parse(data);
    } catch (e) {
      json = data;
    }

    var mapped = ko.mapping.fromJS(json, self.mapping);

    self.archivedArticles(mapped.articles());
    self.pagination(mapped.pagination());
  };

  self.request = function(url) {
    var requestURL,
      path = Kadenze.Routes.archived_articles_path();

    if(url.indexOf('?') > 0) {
      requestURL = path + '?' + url.split('?')[1];
    } else {
      requestURL = path + '?page=0';
    }

    var request = new Kadenze.AjaxRequest({
      url: requestURL,
      type: 'GET',
      dataAsJSON: false,
      loadingIndicator: {
        container: $('#archived-articles-section')
      }
    });

    request.done(function(response) {
      if(response.articles.length) {
        self.bindData(response);
        self.initUI();
      }
    });

    request.fail(self.fail);
  };

  self.fail = function(data) {
    console.warn('Failed to get paginated articles:', data);
    new Kadenze.Notice.error({ message: Kadenze.I18n.t('notice.unexpected_error') });
  };

  self.bindData(params);

  return self;
}